export default "__VITE_ASSET__adc7415e__"